const moduleName = '.auth'

export default ({ context }) => ({
  login: (email, password) => {
    context.lastApiPath = `${moduleName}.login`

    return context.$auth
      .loginWith('local', {
        data: {
          api_user: {
            email,
            password
          }
        }
      })
  },

  logout: () => {
    return context.$auth.logout()
  }
})